import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import batchShopStatuses from '../../constants/BatchShopStatuses';

const styles = {
  root: {
    backgroundColor: '#fff'
  },
  buttonContainer: {
    padding: '10px 26px 10px 26px',
    textAlign: 'right',
    backgroundColor: '#fff'
  },
  button: {
    margin: '5px 5px'
  },
  headerLabel: {
    fontWeight: '500'
  },
  overflow: {
    overflow: 'auto'
  },
  error: {
    width: '50px'
  },
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      listBatchShop: state.shops.listBatchShop
        ? state.shops.listBatchShop.list
        : [],
      totalCount: state.shops.listBatchShop
        ? state.shops.listBatchShop.count
        : 0
    }),
    dispatch => ({
      actions: bindActionCreators({}, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('checked', 'setChecked', () => {
    return new Map();
  }),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    listBatchShop,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    setRowsPerPage
  }) => {
    return (
      <div className={classes.root}>
        <div>
          <div className={classes.buttonContainer} />
          <div className={classes.scrollTable}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>一括登録ID</TableCell>
                  <TableCell>店舗ID</TableCell>
                  <TableCell>店舗名</TableCell>
                  <TableCell>グループID</TableCell>
                  <TableCell>メールアドレス</TableCell>
                  <TableCell>電話番号</TableCell>
                  <TableCell>インポート日時</TableCell>
                  <TableCell>実施日時</TableCell>
                  <TableCell>ステータス</TableCell>
                  <TableCell className={classes.error}>
                    エラーメッセージ
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listBatchShop &&
                  listBatchShop.map(listShop => (
                    <TableRow>
                      <TableCell>{listShop.batchLogId}</TableCell>
                      <TableCell>{listShop.shopId}</TableCell>
                      <TableCell>{listShop.shopName}</TableCell>
                      <TableCell>{listShop.groupId}</TableCell>
                      <TableCell>{listShop.email}</TableCell>
                      <TableCell>{listShop.phone}</TableCell>
                      <TableCell>{listShop.createdAt}</TableCell>
                      <TableCell>{listShop.executeDate}</TableCell>
                      <TableCell>
                        {batchShopStatuses.map(item => {
                          return item.value === listShop.status
                            ? item.name
                            : '';
                        })}
                      </TableCell>
                      <TableCell>{listShop.errorMessage}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>

          <ExPaginationGroup
            count={
              totalCount % rowsPerPage > 0
                ? Math.floor(totalCount / rowsPerPage) + 1
                : Math.floor(totalCount / rowsPerPage)
            }
            selectedPage={page}
            handleChangePage={(e, p, limit) => handleChangePage(e, p, limit)}
            limit={rowsPerPage}
            totalCount={totalCount}
            setLimit={setRowsPerPage}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
